export default {
  path: '/license-qualifier-labels',
  name: 'license-qualifier-labels',
  component: () => import(/* webpackChunkName: "license-qualifier-labels" */ './QualifierLabels'),
  meta: {
    requiresAuth: true
  }
}
